<template>
  <div>
    <v-col cols="12" class="px-0">
      <v-card class="datSectionTable">
        <!-- Cabecera de Tabla -->
        <v-card-title class="py-3">
          <v-col cols="6" md="3" class="order-2 order-md-1 py-1 mr-auto mt-auto" >
            <v-text-field v-model="dSearch" prepend-inner-icon="mdi-magnify" color="datPrimary" class="mt-0 py-0" :placeholder="$t('labels.search')" single-line hide-details></v-text-field>
          </v-col>
          <!-- Botón de filtros -->
          <v-col cols="auto" class="order-1 order-md-2 pa-0" :key="dFilterBadge">
            <v-tooltip color="datSecondary" bottom>
              <template v-slot:activator="tooltip">
                <v-badge v-if="dFilterBadge" color="datWarning" overlap :offset-x="10" :offset-y="10" dot>
                  <v-btn depressed icon @click="fFiltersModal()" v-on="tooltip.on">
                    <v-icon color="datPrimary">mdi-filter-outline</v-icon>
                  </v-btn>
                </v-badge>
                <v-btn v-else depressed icon @click="fFiltersModal()" v-on="tooltip.on">
                  <v-icon color="datPrimary">mdi-filter-outline</v-icon>
                </v-btn>
              </template>
              <span>
                <p class="ffP fs14 fcWhite mb-0">{{$t('datGeneric.filters')}}</p>
              </span>
            </v-tooltip>
          </v-col>
          <!-- Botón de nueva denuncia -->
          <v-col v-if="pAllowNewComplaint == 'true'" cols="6" md="auto" class="order-1 order-md-2 py-1" >
            <v-btn dark depressed class="datPrimaryBtn" @click="fGoToComplaintDetail()">
              {{$t('btn.newComplaint')}}
            </v-btn>
          </v-col>
          <!-- Botón de mantenimiento de tipos de denuncias -->
          <v-col v-if="dManager === 'S'" cols="6" md="auto" class="order-1 order-md-2 py-1" >
            <v-btn dark depressed class="datPrimaryBtnOut" @click="fTypeComplaintModal()">
              {{$t('btn.compTypes')}}
            </v-btn>
          </v-col>            
          <!-- Denuncia de consulta anónima -->
          <v-col v-else cols="6" md="auto" class="order-1 order-md-2 py-1" >
            <v-btn dark depressed class="datPrimaryBtnOut" @click="fShowAnonymComplaint()">
              {{$t('btn.consultAnonym')}}
            </v-btn>
          </v-col>
        </v-card-title>

        <!-- Tabla -->
        <v-card-text class="py-4">
          <v-data-table :headers="dComplaintsTableHeaders" 
                        :items="dComplaints" 
                        :loading="dLoadingTable" 
                        :options.sync="dPagination" 
                        :server-items-length="dTotalRows" 
                        :items-per-page="10" 
                        :item-key="dItemKey" 
                        :header-props="dHeaderProps"
                        :noDataText="$t('datGeneric.noData')" 
                        :loading-text="$t('labels.loadingItems')" 
                        :footer-props="{'items-per-page-options':[5,10,20], 'items-per-page-text': $t('labels.elementsPerPage'), 'pageText': '{0}-{1} de {2}' }" 
                        class="datTable" >
            <template v-slot:progress>
              <v-progress-linear v-if="dLoadingTable" color="datPrimary" indeterminate height="2"></v-progress-linear>
            </template>

            <!-- Fecha formateada -->
            <template v-slot:[`item.creationDate`]="{ item }">
              <v-row class="ma-0">
                <v-col cols="auto" class="pa-0">
                  <span class="mt-4">{{fDateFormat(item.creationDate)}}</span>
                  <br v-if="item.limitDate && dManager === 'S' && item.status !== 'RECHAZADA'" />
                  <span v-if="item.limitDate && dManager === 'S'  && item.status !== 'RECHAZADA'" :class="fLimitDaysClass(item)" >{{$t('datGeneric.actDays')}} {{fLimitDays(item)}} {{$t('datGeneric.days')}}</span>
                </v-col>
              </v-row>
            </template>

            <!-- Etiqueta estado -->
            <template v-slot:[`item.status`]="{ item }">
              <v-chip small :color="fGetStatusColor(item.status)">{{ fGetStatusLabel(item.status) }}</v-chip>
            </template>

            <!-- Ir a Detalle de sobre -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom color="datSecondary">
                <template v-slot:activator="tooltip">
                  <v-btn v-on="tooltip.on" @click="fGoToComplaintDetail(item)" color="datPrimary" icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('datFormsTitles.comDetail')}}</span>
              </v-tooltip>
              
              <!-- Cambios de estado -->
              <v-tooltip v-if="dManager === 'S'" color="datSecondary" bottom>
                <template v-slot:activator="tooltip">
                  <v-btn v-on="tooltip.on" @click="fOpenManageModal(item)" color="datPrimary" icon>
                    <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('btn.manageComplaint')}}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Modal gestión de denuncias-->
    <datModal v-model="dShowManageModal" :pWidth="600" :pTitle="$t('btn.manageComplaint')">
      <eComplaintManageModal @close="fCloseManageModal" :pComplaintInfo="dSelectedComplaint" />
    </datModal>
    <!-- Modal de tipos de denuncia -->
    <datModal v-model="dShowCompType" :pTitle="$t('compDetails.typeId')" :pWidth="900">
      <eComplaintsTypes />
    </datModal> 
    <!-- Modal de búsqueda de denuncia anónima -->
    <datModal v-model="dShowAnonymModal" :pTitle="$t('btn.consultAnonym')" :pWidth="900">
      <eAnonymComplModal  @close="fCloseAnonymModal" />
    </datModal>  
    <!-- Modal de Filtro -->
    <datModal v-if="dShowFilters" v-model="dShowFilters" :pWidth="600" :pTitle="$t('datFormsTitles.filters')" >
      <eComplaintFiltersModal :key="dShowFilters"  :pFilters="dFilters" @close="fFiltersModal"  />
    </datModal>       
  </div>
</template>
<script>

//Servicios
import ServiceEcomplaints from '@/services/srv-eComplaints'
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'

// Componentes
import eComplaintsTypes from '@/components/EComplaints/eComplaintTypes.vue'
import eComplaintManageModal from '@/components/EComplaints/complaintDetail/modals/eComplaintManageModal'
import eAnonymComplModal from '@/components/EComplaints/complaintDetail/modals/eAnonymComplModal'
import eComplaintFiltersModal from '@/components/EComplaints/complaintDetail/modals/eComplaintFiltersModal' 
import datModal from '@/components/datModal'

export default {
  mixins: [mxCanalDenuncias],

  components: {
    eComplaintManageModal,
    eComplaintFiltersModal,
    datModal,
    eComplaintsTypes,
    eAnonymComplModal
  },

  mounted(){
    this.fInitTable()
  },

  props: {
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    },
    pStatus:{ 
      type: String,
      default: null
    },
    pAllowNewComplaint:{   
      type: String,
      default: 'true' 
    }
  },

  data () {
    return {
      dSearch:'',
      dCurrentSearchTime: null,
      dTotalRows: 1,
      dFilters: {},
      dFilterBadge: false,
      dPagination: null,
      dLoadingTable: false,
      dComplaints: [],
      dComplaintsTableHeaders: [
        { text: this.$t('datTableHeader.complaintId'),       value: 'auxId',        align: 'left',  sortable: true,   class: ''},
        { text: this.$t('datTableHeader.title'),             value: 'title',        align: 'left',  sortable: true,   class: ''},
        { text: this.$t('labels.creationUser'),              value: 'userName',     align: 'left',  sortable: true,   class: ''},
        { text: this.$t('datTableHeader.creationDate'),      value: 'creationDate', align: 'left',  sortable: true,   class: ''},
        { text: this.$t('datTableHeader.status'),            value: 'status',       align: 'left',  sortable: true,   class: ''},
        { text: this.$t('datGeneric.detail'),                value: 'actions',      align: 'center',sortable: false,  class: ''}
      ],
      dItemKey: 'complaintId',
      dShowCompType: false,
      dShowManageModal: false,
      dShowAnonymModal: false,  
      dShowFilters: false,    
      dSelectedComplaint: {},
      dManager: localStorage.getItem("manager") ? localStorage.getItem("manager") : 'N',
      dHeaderProps: {sortByText: this.$t('datGeneric.sortBy')}
    }
  },
  methods: {
    
    // Inicializa al componente
    fInitTable(){
      this.dPagination.page = 1
      this.fGetComplaints()
    },

    // Devuelve el listado de denuncias creadas
    fGetComplaints(){
      this.dLoadingTable = true
      const payload = {
        status: this.dFilters.status ? this.dFilters.status : this.pStatus ,
        complainant: this.dFilters.complainant,
        iniDate: this.dFilters.iniDate,
        endDate: this.dFilters.endDate,
        typeId: this.dFilters.typeId,
        search: this.dSearch,
        searchCols: 'title, status, userName',
        numRows: this.dPagination.itemsPerPage,
        offset: ((this.dPagination.page-1) * this.dPagination.itemsPerPage) + 1,
        orderBy: this.dPagination.sortBy[0] ? this.dPagination.sortBy[0] : this.dItemKey,
        order: this.dPagination.sortDesc[0] ? 'ASC' : 'DESC',
      }

      ServiceEcomplaints.getComplaints(payload).then(response => {
        this.dComplaints = response.dataRes
        this.dTotalRows = response.numReg
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      }).finally(() => {
        this.dLoadingTable = false
      })
    },

    fLimitDays(item){
      const endDate = new Date(item.limitDate)

      const iniDate = new Date()
      iniDate.setHours(0,0,0,0)

      // Calculate the difference in milliseconds
      const diffDays = endDate - iniDate 

      // Convert back to days and return
      return Math.floor(diffDays / (1000 * 60 * 60 * 24))
    },

    fLimitDaysClass(item){
      const days = this.fLimitDays(item)
      let clase
      if (days <= 5){
        clase = 'subInfoLimit'
      } else if (days <= 10){
        clase = 'subInfoWarning'
      }else {
        clase = 'subInfo'
      }
      return clase
    },

    // Accede al detalle de un sobre 
    fGoToComplaintDetail(complaintInfo){
      this.$emit('go-to-detail', complaintInfo)
    },

    fTypeComplaintModal(){
      this.dShowCompType = !this.dShowCompType
    },

    fFiltersModal(filters){
      this.dShowFilters = !this.dShowFilters
      if(filters){
        this.dFilterBadge = true
        this.dFilters = filters
        this.fGetComplaints() 
      }else{
        this.dFilterBadge = false
      }
    },

    // Abre la modal de rechazo para las denuncias rechazadas
    fOpenManageModal(complaint){
      this.dSelectedComplaint = complaint
      this.dShowManageModal = true
    },

    // Cierra la modal de actualización de estados y actualiza la tabla de denuncias
    fCloseManageModal(reload){
      this.dShowManageModal = false 
      if(reload){
        this.fGetComplaints()
        this.$emit('reload-kpis')
      }
    },

    fCloseAnonymModal(complaintInfo){
      this.dShowAnonymModal = false 
      if(complaintInfo){
        this.fGoToComplaintDetail(complaintInfo)
      }
    },

    // Muestra la modal de consulta de denuncia anónima
    fShowAnonymComplaint(){
      this.dShowAnonymModal = true
    }
  },

  watch:{
    dSearch(){
			clearTimeout(this.dCurrentSearchTime)
			this.dCurrentSearchTime = setTimeout(() => {
        this.dPagination.page = 1
				this.fGetComplaints()
			}, 1000)
    },
    dPagination(){
      this.fGetComplaints()
    }
  }
}
</script>